// extracted by mini-css-extract-plugin
export default {"NavBar":"SettingsLayout_NavBar__b05D7"};